// Task tracker status values emitted by the BE for AION_INGEST_* ingestion steps.
// PROCESSING is also reused as the client-side "polling in flight" marker (see RelatedParties.tsx).
export const TASK_TRACKER_STATUS = {
    TODO: 'TODO',
    TODO_ASYNC: 'TODO_ASYNC',
    PROCESSING: 'PROCESSING',
    COMPLETE: 'COMPLETE',
    FAILED: 'FAILED',
    FAILURE: 'FAILURE',
} as const;

// The BE emits both FAILED and FAILURE for a terminally-failed ingest step — a polling ladder
// treats them identically: stop polling, show no loader.
export function isTerminalFailure(status?: string): boolean {
    return status === TASK_TRACKER_STATUS.FAILED || status === TASK_TRACKER_STATUS.FAILURE;
}

// Shared header-indicator copy for a terminally-failed tracker — one string for both Legal
// Cases and Regulatory Checks, so the two sections can never drift apart.
export const FETCH_FAILURE_TEXT = 'Not able to fetch';
